module.exports = __webpack_public_path__ + "img/Responsiveness-2022.82ad2447.png";